import PropTypes from 'prop-types';
import React from 'react';
import {ColorField, SelectFormField} from '..';
import {AVAILABLE_FONTS, TICKER_DEFAULTS, TICKER_SPEEDS} from '../../constants/config';
import Box from '../layout/Box';

const TickerInfoEditor = ({ticker, onChange}) => {
  const {is_url, speed, font_family, font_size, colour, outline, background} = ticker;

  return (
    <Box direction="column">
      <label htmlFor="isURL">
        <input id="isURL" type="checkbox" checked={is_url} onChange={e => onChange({is_url: e.target.checked})}/>Is URL
      </label>
      <SelectFormField id="speed" label="Speed"
                       defaultValue={speed} options={TICKER_SPEEDS}
                       onChange={(e) => onChange({speed: e.currentTarget.value})}/>
      <SelectFormField id="fontFamily" label="Font Family"
                       defaultValue={font_family} options={AVAILABLE_FONTS}
                       onChange={(e) => onChange({font_family: e.currentTarget.value})}/>
      <label htmlFor="fontSize">Font Size
        <input type="number" id="fontSize" defaultValue={font_size} min={8} max={120}
               onChange={(e) => onChange({font_size: e.target.value})}/>
      </label>
      <ColorField label="Text Colour" defaultValue={colour} resetValue={TICKER_DEFAULTS.colour}
                  onChange={(color) => onChange({colour: color})}/>
      <ColorField label="Outline Colour" defaultValue={outline} resetValue={TICKER_DEFAULTS.outline}
                  onChange={(color) => onChange({outline: color})}/>
      <ColorField label="Background Colour" defaultValue={background}
                  resetValue={TICKER_DEFAULTS.background}
                  onChange={(color) => onChange({background: color})}/>
    </Box>
  );
};

TickerInfoEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  ticker: PropTypes.shape({
    speed: PropTypes.number.isRequired,
    font_family: PropTypes.string.isRequired,
    font_size: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number],
    ).isRequired,
    colour: PropTypes.string.isRequired,
    outline: PropTypes.string.isRequired,
    background: PropTypes.string.isRequired,
  }).isRequired,
};

export default TickerInfoEditor;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/TickerInfoEditor/index.js